
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Edit, Trash2, ArrowLeft, Shield } from 'lucide-react';

interface Team {
  id: string;
  name: string;
  profile_picture_url?: string | null;
  clubs?: {
    id: string;
    name: string;
  } | null;
}

interface TeamPageHeaderProps {
  team: Team;
  onEditClick: () => void;
  onDeleteClick: () => void;
}

export const TeamPageHeader = ({ team, onEditClick, onDeleteClick }: TeamPageHeaderProps) => {
  return (
    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-8">
      <div>
        <h1 className="text-3xl font-bold flex items-center gap-3">
          <Avatar className="h-10 w-10">
            <AvatarImage src={team.profile_picture_url} alt={team.name} />
            <AvatarFallback>
              <Shield className="h-6 w-6 text-blue-600" />
            </AvatarFallback>
          </Avatar>
          {team.name}
        </h1>
        <p className="text-muted-foreground mt-2">
          Manage coaches, players and team details
        </p>
      </div>
      <div className="flex flex-col sm:flex-row gap-2">
        <Button variant="outline" onClick={onEditClick} className="w-full sm:w-auto">
          <Edit className="h-4 w-4 mr-2" />
          Edit Team
        </Button>
        <Button variant="destructive" onClick={onDeleteClick} className="w-full sm:w-auto">
          <Trash2 className="h-4 w-4 mr-2" />
          Delete Team
        </Button>
        <Button asChild variant="outline" className="w-full sm:w-auto">
          <Link to={team.clubs ? `/superadmin/club/${team.clubs.id}` : '/superadmin'}>
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Club
          </Link>
        </Button>
      </div>
    </div>
  );
};
